<script lang="ts">
    import ListsPage from '@Alternatives/AlternativesViews/Pages/ListsPage'
    export default ListsPage
</script>

<template>
    <div>
        <AlternativesViewDeleterDialog :viewModel="alternativesViewDeleterDialog"
                                       @delete-list="handleDeleteAlternativesViewCommand" />
        
        <AlternativesViewDependenciesDialog :viewModel="alternativesViewDependenciesDialog" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Lists</h1>
                    <p class="text-muted mb-0">Build custom lists to structure and analyse your portfolio by combining Kanban Statuses, Attribute values and existing lists.</p>
                </div>
                <div class="col-lg-5 text-right align-self-end">
                    <div class="dropdown">
                        <button class="btn btn-success" style="padding: 0.7em 2em;" type="button" data-toggle="dropdown">
                            Create list
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" @click="createStaticList">
                                <strong>Static</strong><br />
                                Manage list items manually
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" @click="createActiveList"><strong>Active</strong><br />Dynamic list based on your conditions</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">
            <div class="row" style="margin: 0; height: 100%;">
                <div class="col-sm-3 bg-color-gray4" style="height: 100%;">
                    <div style="margin: 20px 5px;">
                        <input type="search" v-model="listSearchPhrase" class="form-control" placeholder="Type to search..." />

                        <ul class="list-group" v-for="l in listsView" :key="l.Id">
                            <li class="list-group-item pointer" @click="SelectView(l.Id)" :class="{'active' : SelectedView?.Id === l.Id }">
                                <span>
                                    <i v-if="!l.IsValid" class="fa fa-exclamation-triangle fa-lg fg-color-red"></i>
                                    <i v-if="l.IsValid && !l.IsStatic" class="fa fa-filter fa-lg"></i>
                                    <i v-if="l.IsValid && l.IsStatic" class="fa fa-list fa-lg"></i>
                                    {{l.Name}}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-sm-9">
                    <div v-if="SelectedView" style="margin: 10px;">
                        <div v-if="IsEdited === false">
                            <div class="row">
                                <div class="col-sm-6">
                                    <h4>
                                        <span>{{SelectedView.Name}}</span>
                                        <small>({{SelectedView.Included?.length}})</small>
                                    </h4>
                                </div>
                                <div class="col-sm-6" style="text-align: right;">
                                    <div class="dropdown d-inline-block">
                                        <a class="text-dark dropdown-toggle" data-toggle="dropdown">
                                            Actions
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item" @click="startListEditing">Edit</a>
                                            <a class="dropdown-item" @click="cloneList">Clone</a>
                                            <a class="dropdown-item" @click="cloneAsStaticList">Save as static list</a>
                                            <a class="dropdown-item" @click="showListDependenciesViewer">View dependencies</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="showListDeleter">Delete</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                        </div>

                        <div v-if="IsEdited === true">
                            <div class="row">
                                <div class="col-sm-3">
                                    <strong>List name:</strong>
                                </div>
                                <div class="col-sm-6"></div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="text" v-model.trim="SelectedView.Name" class="form-control" />
                                </div>
                                <div class="col-sm-6">
                                    <button role="button" class="btn btn-primary mr-1" @click="SaveCommand">Save</button>
                                    <button role="button" class="btn btn-outline-secondary" @click="cancelListEditing">Cancel</button>
                                </div>
                            </div>
                            <br />
                        </div>

                        <div v-if="IsEdited && !SelectedView.IsStatic">
                            <div class="card">
                                <div class="card-header">
                                    <div class="dropdown">
                                        <span class="mr-1" v-if="filter.Type === 'And'">Include when all of conditions are met</span>
                                        <span class="mr-1" v-if="filter.Type === 'Or'">Include when any of conditions are met</span>
                                        <a class="fa fa-cog pointer" data-toggle="dropdown"></a>

                                        <div class="dropdown-menu">
                                            <div class="dropdown-header">Include when:</div>
                                            <a class="dropdown-item" @click="filter.Type = 'And'">
                                                <span class="fa-regular fa-square-check" v-if="filter.Type === 'And'"></span>
                                                <span class="fa-regular fa-square" v-if="filter.Type === 'Or'"></span>
                                                all of conditions are met
                                            </a>
                                            <a class="dropdown-item" @click="filter.Type = 'Or'">
                                                <span class="fa-regular fa-square-check" v-if="filter.Type === 'Or'"></span>
                                                <span class="fa-regular fa-square" v-if="filter.Type === 'And'"></span>
                                                any of conditions are met
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div v-for="f in filter.Filters">
                                        <AttributeFilter v-if="f.IsPropertyFilter" 
                                                         :propRm="f" 
                                                         :propAttributes="rm.Attributes" 
                                                         @deleteFilter="deleteFilter" />
                                        
                                        <StatusFilter v-if="f.IsStatusFilter" 
                                                      :propRm="f" 
                                                      :propStatuses="rm.Statuses" 
                                                      @deleteFilter="deleteFilter" />
                                        
                                        <ListFilter v-if="f.IsMemberFilter" 
                                                    :propRm="f" 
                                                    :propViews="rm.Views" 
                                                    @deleteFilter="deleteFilter" />

                                    </div>

                                    <div class="dropdown" style="display: inline-block;">
                                        <a class="pointer" style="font-size: 14px;" data-toggle="dropdown">
                                            <span class="fa fa-plus"></span>
                                            Add condition
                                        </a>

                                        <div class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
                                            <div class="dropdown-header">Status:</div>
                                            <a class="dropdown-item" @click="addFilter('StatusIn')">is one of</a>
                                            <a class="dropdown-item" @click="addFilter('StatusNotIn')">is none of</a>
                                            <div class="dropdown-divider"></div>

                                            <div class="dropdown-header">Attribute value:</div>
                                            <a class="dropdown-item" @click="addFilter('PropertyEq')">equal to</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyNotEq')">NOT equal to</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyLt')">is less than</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyLte')">is less than or equal to</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyGt')">is greater than</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyGte')">is greater than or equal to</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyIsKnown')">any value</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyIsUnknown')">no value</a>
                                            <a class="dropdown-item" @click="addFilter('PropertyContains')">contains</a>
                                            <div class="dropdown-divider"></div>

                                            <div class="dropdown-header">List:</div>
                                            <a class="dropdown-item" @click="addFilter('MemberOf')">is included</a>
                                            <a class="dropdown-item" @click="addFilter('NotMemberOf')">is NOT included</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <input type="search" v-model="alternativesSearchPhrase" class="form-control" placeholder="Type to search by name..." />

                        <table v-if="IsEdited && SelectedView.IsStatic" class="table table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody v-for="a in alternativesView" :key="a.Id">
                                <tr>
                                    <td>
                                        <span v-if="IsEditedIncluded(a.AlternativeId)" @click="Exclude(a.AlternativeId)" class="fa-regular fa-square-check"></span>
                                        <span v-if="!IsEditedIncluded(a.AlternativeId)" @click="Include(a.AlternativeId)" class="fa-regular fa-square"></span>
                                    </td>
                                    <td>{{a.Name}}</td>
                                    <td>{{a.Description}}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table v-if="!IsEdited" class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody v-for="a in alternativesView" :key="a.Id">
                                <tr>
                                    <td>{{a.Name}}</td>
                                    <td>{{a.Description}}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<style scoped>

</style>


